<!--  -->
<template>
  <div class="aboutUs">
      <h1>关于我们</h1>
    <p>
      启航教育隶属于北京爱启航网络科技有限公司，是国内从事考研培训的教育品牌，包括“启航教育在线”、“启航考试培训学校”和“启航图书”三大业务板块。
    </p>
    <p>面授教育：启航考试培训学校</p>
    <p>
      启航教育研发了服务设施齐全的龙腾集训营，拥有小班面授、高端辅导的龙腾周末班。采用翻转课堂教学模式，线上依托启航教育名师课堂，线下实施教研团队小班面授。
    </p>
    <p>在线教育：启航教育在线</p>
    <p>
      启航教育在线搭建完成“启航教育”Web平台、“启航教育”H5平台、“启航个性化打卡”小程序、“启航教育”APP，2018，启航教育推出线上线下相结合的“双师课堂”。通过数字化方式形成实时反馈、自动诊断的教育系统。
    </p>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.aboutUs{
    padding: 36px;
    h1{
        padding:0 0 40px 0;
        font-weight: 800;
        font-size: 32px;
        text-align: center;
    }
    p{
        color: #333;
        font-size: 28px;
        line-height: 40px;
    }
}
</style>
